function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { GridColumn, GridRow, H2, H3, H4, P, Icon, Logo, Subheader, Link, ButtonPrimary } from "../";
const STSContainer = styled(GridRow)`
  margin-top: 3.294vw;
  @media only screen and ${props => props.theme.media.extraLarge} {
    margin-top: 56px;
  }
`;
const STSLogo = styled(Logo)`
  flex-shrink: 0;
  margin-right: 1.84vw;
  width: ${props => props.variant ? "5.215vw" : "6.902vw"};
  height: ${props => props.variant ? "5.215vw" : "6.902vw"};
  @media only screen and ${props => props.theme.media.large} {
    width: ${props => props.variant ? "5.982vw" : "78px"};
    height: ${props => props.variant ? "5.982vw" : "78px"};
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    width: 78px;
    height: 78px;
    margin-right: 24px;
  }
`;
const STSDetails = styled(GridColumn)``;
const VoteText = styled(P)`
  font-size: 14px;
  font-weight: 800;
  margin-bottom: 1.227vw;
  text-align: center;
  @media only screen and ${props => props.theme.media.medium} {
    ${props => props.variant && "max-width: 224px"};
  }
  @media only screen and ${props => props.theme.media.large} {
    font-size: ${props => props.variant ? "1.104vw" : "1.304vw"};
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    font-size: 17px;
    margin-bottom: 16px;
  }
`;
const STSButton = styled(ButtonPrimary)`
  background-color: ${props => props.theme.palette.teal.primary};
  svg {
    margin-left: 12px;
    path {
      fill: #fff;
    }
  }
  &:hover,
  &:focus {
    background-color: ${props => props.theme.palette.teal.darker};
  }
`;
const PurchasePill = styled(GridRow)`
  background-color: ${props => props.theme.palette.purple.darker};
  border-radius: 24.5px;
  margin-bottom: 2.256vw;
  height: 4.605vw;
  width: 32.237vw;
  @media only screen and ${props => props.theme.media.large} {
    font-size: 17px;
    margin-bottom: 24px;
    height: 49px;
    width: 343px;
  }
`;
const PurchasedText = styled(H4)`
  color: #ffffff;
  font-size: 1.598vw;
  font-weight: 700;
  @media only screen and ${props => props.theme.media.large} {
    font-size: 17px;
  }
`;
const TicketIcon = styled(Icon)`
  margin-right: 1.504vw;
  width: 3.008vw;
  height: 3.008vw;
  path {
    fill: #fff;
  }
  @media only screen and ${props => props.theme.media.large} {
    margin-right: 16px;
    width: 32px;
    height: 32px;
  }
`;
export const TicketLarge = ({
  show,
  preShow,
  purchased,
  onActionClick,
  onLinkClick,
  ...props
}) => React.createElement(TicketContainer, _extends({
  variant: preShow
}, props), React.createElement(Container, {
  xCenter: true,
  yCenter: true,
  stretch: true,
  variant: preShow,
  purchased: purchased
}, purchased && React.createElement(PurchasePill, {
  xCenter: true,
  yCenter: true
}, React.createElement(TicketIcon, {
  tertiary: true,
  name: "Ticket"
}), React.createElement(PurchasedText, null, "You Have a Ticket To The Show!")), React.createElement(ArtistName, null, show.artist), React.createElement(Subtitle, {
  variant: preShow
}, show.subtitle), React.createElement(EventDetails, {
  xCenter: true,
  yCenter: true,
  variant: preShow
}, preShow && React.createElement(Icon, {
  form: true,
  name: "Calendar"
}), " Live ", show.date, " at", " ", show.time, " (", show.length, " Show)"), !!show.description && !preShow && !purchased && React.createElement(Description, null, show.description.length > 158 ? show.description.substr(1, 158) + "..." : show.description), !!purchased ? React.createElement(STSContainer, {
  yStart: true
}, React.createElement(STSLogo, {
  variant: !preShow,
  name: "SetTheSetDefault"
}), React.createElement(STSDetails, null, React.createElement(VoteText, {
  variant: !preShow
}, "Vote for your show\u2019s set list on Set The Set!"), React.createElement(STSButton, {
  onClick: onActionClick
}, "Go To Set The Set ", React.createElement(Icon, {
  tertiary: true,
  name: "Next"
})))) : React.createElement(PaddedContainer, {
  xCenter: true
}, React.createElement(Price, null, show.price), React.createElement(Purchase, {
  onClick: onActionClick
}, "Get Your Front Row Ticket!"), !preShow && React.createElement(MoreLink, {
  onClick: onLinkClick
}, "Learn More"))), React.createElement(DividerContainer, null, React.createElement(Divider, {
  variant: purchased,
  yCenter: true,
  noShrink: true
}, React.createElement(Caret, {
  variant: purchased
}))), React.createElement(Artist, {
  variant: preShow,
  image: show.image
}, show.requests && React.createElement(React.Fragment, null, React.createElement(CallOut, null), React.createElement(Requests, {
  xCenter: true
}, React.createElement(STSIcon, {
  name: "SetTheSetReversed"
}), React.createElement(RequestText, null, "Accepting Song Requests")))));
const TicketContainer = styled(GridRow)`
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  & + & {
    margin-top: 24px;
  }
`;
const ArtistName = styled(H2)`
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 4px;
  @media only screen and ${props => props.theme.media.medium} {
    font-size: 28px;
    line-height: 32px;
  }
  @media only screen and ${props => props.theme.media.large} {
    font-size: 3.067vw;
    line-height: 3.374vw;
    margin-bottom: 0.307vw;
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    font-size: 40px;
    line-height: 44px;
    margin-bottom: 4px;
  }
`;
const Subtitle = styled(Subheader)`
  font-weight: ${props => props.variant ? 600 : 700};
  @media only screen and ${props => props.theme.media.medium} {
    font-size: ${props => props.variant ? "1.917vw" : "14px"};
    line-height: ${props => props.variant ? "2.454vw" : "18px"};
  }
  @media only screen and ${props => props.theme.media.large} {
    font-size: ${props => props.variant ? "1.917vw" : "1.074vw"};
    line-height: ${props => props.variant ? "2.454vw" : "1.687vw"};
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    font-size: ${props => props.variant ? "25px" : "14px"};
    line-height: ${props => props.variant ? "32px" : "22px"};
  }
`;
const EventDetails = styled(GridRow)`
  border-bottom: 2px solid ${props => props.theme.colors.disabledFill};
  color: ${props => props.variant ? props.theme.palette.black : props.theme.palette.orange.primary};
  font-size: ${props => props.variant ? "25px" : "17px"};
  font-weight: 700;
  line-height: ${props => props.variant ? "32px" : "24px"};
  width: 100%;
  svg {
    margin-right: 9px;
    path {
      fill: ${props => props.theme.palette.black};
    }
  }
  @media only screen and ${props => props.theme.media.medium} {
    font-size: 14px;
    margin-top: 16px;
    padding-bottom: 8px;
  }
  @media only screen and ${props => props.theme.media.large} {
    font-size: 1.304vw;
    margin-top: 1.84vw;
    padding-bottom: 1.227vw;
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    font-size: 17px;
    margin-top: 24px;
    padding-bottom: 16px;
  }
`;
const Description = styled(GridColumn)`
  text-align: left;
  width: 100%;
  @media only screen and ${props => props.theme.media.medium} {
    margin-top: 4px;
    font-size: 14px;
    line-height: 18px;
  }
  @media only screen and ${props => props.theme.media.large} {
    margin-top: 0.613vw;
    line-height: 2.071vw;
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    margin-top: 8px;
    line-height: 27px;
  }
`;
const Price = styled(H3)`
  font-weight: 900;
  letter-spacing: 0;
  text-align: center;

  @media only screen and ${props => props.theme.media.medium} {
    font-size: 18px;
    line-height: 25px;
    margin-top: 20px;
  }
  @media only screen and ${props => props.theme.media.large} {
    font-size: 1.917vw;
    line-height: 2.454vw;
    margin-top: 3.067vw;
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    font-size: 25px;
    line-height: 32px;
    margin-top: 40px;
  }
`;
const PaddedContainer = styled(GridColumn)`
  padding: 0 18px;
  width: 100%;
  max-width: 392px;
`;
const Purchase = styled(ButtonPrimary)`
  margin-top: 1.227vw;
  width: 100%;
  @media only screen and ${props => props.theme.media.extraLarge} {
    margin-top: 16px;
  }
`;
const MoreLink = styled(Link)`
  justify-content: center;
  width: 105px;
  @media only screen and ${props => props.theme.media.medium} {
    font-size: 12px;
    line-height: 40px;
    margin-top: 4px;
  }
  @media only screen and ${props => props.theme.media.large} {
    font-size: 1.304vw;
    line-height: 3.067vw;
    margin-top: 0.613vw;
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    font-size: 17px;
    line-height: 40px;
    margin-top: 8px;
  }
`;
const DividerContainer = styled(GridRow)`
  background-color: #fff;
  flex-shrink: 0;
  overflow: hidden;
  @media only screen and ${props => props.theme.media.medium} {
    width: 20px;
  }
  @media only screen and ${props => props.theme.media.large} {
    width: 36px;
  }
`;
const Divider = styled(GridRow)`
  background-color: ${props => props.theme.ticket.divider[props.variant ? "secondary" : "default"]};
  margin-left: 20px;
  position: relative;
  min-height: 100%;
  width: 16px;
  @media only screen and ${props => props.theme.media.medium} {
    margin-left: 13px;
    width: 7px;
  }
  @media only screen and ${props => props.theme.media.large} {
    margin-left: 20px;
    width: 16px;
  }
`;
const Caret = styled.div`
  background-color: ${props => props.theme.ticket.divider[props.variant ? "secondary" : "default"]};
  display: block;
  position: absolute;
  transform: rotate(45deg);
  height: 30px;
  width: 30px;
  @media only screen and ${props => props.theme.media.medium} {
    right: -3px;
    height: 18px;
    width: 18px;
  }
  @media only screen and ${props => props.theme.media.large} {
    right: 0px;
    height: 30px;
    width: 30px;
  }
`;
const Container = styled(GridColumn)`
  background-color: #fff;
  text-align: center;
  border-top-left-radius: ${props => props.variant ? "16px" : 0};
  border-bottom-left-radius: ${props => props.variant ? "16px" : 0};
  @media only screen and ${props => props.theme.media.medium} {
    padding: 24px 32px;
  }
  @media only screen and ${props => props.theme.media.large} {
    padding: ${props => props.variant ? "24px 5.215vw 24px 6.135vw" : "24px 56px"};
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    padding: ${props => props.variant ? "24px 68px 24px 80px" : props.purchased ? "24px 46px" : "24px 56px"};
  }
`;
const Artist = styled(GridColumn)`
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center 40%;
  border-top-right-radius: ${props => props.variant ? "16px" : 0};
  border-bottom-right-radius: ${props => props.variant ? "16px" : 0};
  padding-bottom: ${props => props.variant ? "40.5%" : "39.12%"};
  position: relative;
  width: ${props => props.variant ? "40.5%" : "55.82%"};
  flex-shrink: 0;
  overflow: hidden;
  @media only screen and ${props => props.theme.media.medium} {
    width: ${props => props.variant ? "40.5%" : "50%"};
  }
  @media only screen and ${props => props.theme.media.extraLarge} {
    width: ${props => props.variant ? "40.5%" : "55.82%"};
  }
`;
const CallOut = styled(GridColumn)`
  background-color: ${props => props.theme.ticket.callOut};
  border-radius: 78px;
  position: absolute;
  top: -32px;
  right: -32px;
  height: 156px;
  width: 156px;
  z-index: 2;
  @media only screen and ${props => props.theme.media.medium} {
    border-radius: 70px;
    top: -20px;
    right: -20px;
    height: 120px;
    width: 120px;
  }
  @media only screen and ${props => props.theme.media.large} {
    border-radius: 78px;
    top: -32px;
    right: -32px;
    height: 156px;
    width: 156px;
  }
`;
const Requests = styled(GridColumn)`
  position: absolute;
  top: 26px;
  right: 16px;
  height: 60px;
  width: 80px;
  z-index: 3;
  @media only screen and ${props => props.theme.media.medium} {
    top: 10px;
    right: 5px;
  }
  @media only screen and ${props => props.theme.media.large} {
    top: 26px;
    right: 16px;
  }
`;
const STSIcon = styled(Logo)`
  flex-shrink: 0;
  margin-bottom: 8px;
  height: 24px;
  width: 24px;
  path {
    fill: #fff;
  }
`;
const RequestText = styled(P)`
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 17px;
  text-align: center;
  width: 80px;
  @media only screen and ${props => props.theme.media.medium} {
    font-size: 10px;
    line-height: 15px;
  }
  @media only screen and ${props => props.theme.media.large} {
    font-size: 11px;
    line-height: 17px;
  }
`;